export { REGISTRANT_OPTIONS } from '../../types/flow'; // This should be removed from the constants file and treated as a type
export { PAYMENT_METHODS } from '../../common/enums'; // All references should be updated to use this import
export { PAYMENT_PROVIDER } from '../../types/payment'; // All references should be updated to use this import

export const GENERIC_PAYMENT_ERROR = 'Payment Error';

export const PAYMENT_METHOD_LABELS = {
  CREDIT_OR_DEBIT__CARD: 'Card Processor Fee',
  CHECK: 'Check Processor Fee',
  ACH_DIRECT_DEBIT: 'Bank Processor Fee',
};

export const CANCELLED_ALERT_MSG =
  'Your transaction has been cancelled. Please enter valid payment details to try again.';
export const ACCOUNT_PICKER_CANCELLED_ALERT_MSG =
  'You have cancelled the account verification process.';
export const ACCOUNT_PICKER_ERROR_ALERT_MSG =
  'An error has occurred while verifying your bank account. Please try again with a different bank account.';
export const DEFAULT_ALERT_MSG = 'Payment Error';
export const PAY_ACH_ERROR =
  'Payment processing for ACH payment methods are currently unavailable. Please try again at another time.';

export enum PROPERTY_MANAGEMENT_OPTIONS {
  SELF_MANAGED = 'selfManaged',
  PROPERTY_MANAGER = 'propertyManager',
  TENANT = 'tenant',
}

// This is kept for backwards compatibility with Apply and Update Admin flows
// The Logic has been simplified to accept just the selectable options, not the labels.
export enum LOCAL_CONTACT_OPTIONS {
  MYSELF = 'ownerRepMyself',
  PROPERTY_MANAGER = 'ownerRepPropertyManager',
  OWNER = 'ownerRepOwner',
  OTHER = 'ownerRepOther',
}

export enum LOCAL_CONTACT {
  PROPERTY_MANAGER = 'propertyManager',
  OWNER = 'owner',
  TENANT = 'tenant',
  OTHER = 'other',
}
